// extracted by mini-css-extract-plugin
export default {"style":"SupprimerProjetFavori_style__jO5jg"};